module.exports = __webpack_public_path__ + "static/media/what_personal.8034d143.jpg";